import React from "react";
import { Bar } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface ChartComponentProps {
    data: {
        Success: {
            low: number;
            mid: number;
            standart: number;
            high: number;
            critical: number;
        };
        Query: {
            low: number;
            mid: number;
            standart: number;
            high: number;
            critical: number;
        };
        Working: {
            low: number;
            mid: number;
            standart: number;
            high: number;
            critical: number;
        };
    };
    maxY?: number; // Добавлен новый пропс для максимального значения оси Y
}

const ChartComponent: React.FC<ChartComponentProps> = ({ data, maxY }) => {

    const chartData = {
        labels: ["В очереди", "В работе", "Успех"],
        datasets: [
            {
                label: "Низкий",
                data: [data.Query.low, data.Working.low, data.Success.low],
                backgroundColor: "rgba(75, 192, 192, 0.6)",
            },
            {
                label: "Средний",
                data: [data.Query.mid, data.Working.mid, data.Success.mid],
                backgroundColor: "rgba(153, 102, 255, 0.6)",
            },
            {
                label: "Стандартный",
                data: [data.Query.standart, data.Working.standart, data.Success.standart],
                backgroundColor: "rgba(255, 206, 86, 0.6)",
            },
            {
                label: "Высокий",
                data: [data.Query.high, data.Working.high, data.Success.high],
                backgroundColor: "rgba(255, 99, 132, 0.6)",
            },
            {
                label: "Критический",
                data: [data.Query.critical, data.Working.critical, data.Success.critical],
                backgroundColor: "rgba(255, 159, 64, 0.6)",
            },
        ],
    };

    const options = {
        plugins:{
            title:{
                display: true,
                text: 'Статистика обращений по уровню критичности'
            }
        },
        scales: {
            y: {
                beginAtZero: true,
                max: maxY || Math.max(
                    data.Query.low,
                    data.Working.low,
                    data.Success.low,
                    data.Query.mid,
                    data.Working.mid,
                    data.Success.mid,
                    data.Query.standart,
                    data.Working.standart,
                    data.Success.standart,
                    data.Query.high,
                    data.Working.high,
                    data.Success.high,
                    data.Query.critical,
                    data.Working.critical,
                    data.Success.critical
                ) + 1,
            }
        }
    };

    return <Bar data={chartData} options={options} />;
};

export default ChartComponent;